// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3bmtd","col":"styles_col__2l5KG"};